import {memo} from 'react';
import CloseIcon from '../../assets/img/icons/redesign-icons/close.svg?react';
import styles from './Modal.module.scss';
import {ModalContainer, ModalContainerProps} from './ModalContainer';

export type ModalProps = ModalContainerProps & {
  title?: string;
  showHeader?: boolean;
  modalTestId?: string;
  closeButtonTestId?: string;
};

export const Modal = memo(
  ({
    children,
    isOpen,
    onClose,
    title,
    showHeader = false,
    modalTestId,
    closeButtonTestId,
    disableBackgroundClick = false,
  }: ModalProps) => {
    return (
      <ModalContainer isOpen={isOpen} onClose={onClose} disableBackgroundClick={disableBackgroundClick}>
        <div className={styles.container} data-test-id={modalTestId}>
          {showHeader && (
            <div className={styles.header}>
              {title && <h2>{title}</h2>}
              <button data-test-id={closeButtonTestId} className={styles.closeButton} onClick={onClose}>
                <CloseIcon />
              </button>
            </div>
          )}
          {children}
        </div>
      </ModalContainer>
    );
  }
);
Modal.displayName = 'Modal';
